import React, {Component} from "react";
import PropTypes from "prop-types";
import DatePicker from "react-datepicker";
import * as moment from "moment";

const propTypes = {
	value: PropTypes.string.isRequired,
	className: PropTypes.string,
	disabled: PropTypes.bool
}

const defaultProps = {
	disabled: false
}

class DatePick extends Component {
	render() {
		return (<DatePicker
			dateFormat="YYYY-MM-DD"
			selected={this.props.value ? moment(this.props.value) : undefined}
			onChange={(value) => this.props.onChange(value ? moment(value).format('YYYY-MM-DD'):"")}
			placeholderText={moment().format('YYYY-MM-DD')}
			className={this.props.className}
			disabled={this.props.disabled}
		/>)
	}
}

DatePick.propTypes = propTypes;
DatePick.defaultProps = defaultProps;

export default DatePick;


// WEBPACK FOOTER //
// ./src/elements/forms/datepicker.jsx